import { useScale } from "common/utils";
import i18n from "features/shared/i18n";

export const Footer = () => {
  const { scale } = useScale();

  const handleOpenLink = (url: string) => {
    if ("ReactNativeWebView" in window) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({ command: "openLink", data: { url: url } }),
      );
    } else {
      window.open(url, "_blank");
    }
  };

  return (
    <div style={{ height: 52 * scale }} className="flex-col-el flex-center w-full bg-white/40">
      <footer
        style={{ transform: `scale(${scale})` }}
        className="flex-row-el flex-center w-[1280px] h-[52px] gap-4 px-6 py-4 text-sm text-gray2-100"
      >
        <span
          className="cursor-pointer hover:text-blue-100 hover:underline transition-colors"
          onClick={() => handleOpenLink("https://inexus-co.com/product/")}
        >
          {i18n.t("MSG_SETTING_FOOTER_GO_TO_SITE")}
        </span>
        <span>|</span>
        <span
          className="cursor-pointer hover:text-blue-100 hover:underline transition-colors"
          onClick={() => handleOpenLink("https://inexus-co.com/privacy-policy/")}
        >
          {i18n.t("MSG_SETTING_FOOTER_TERMS_OF_SERVICE")}
        </span>
        <span>|</span>
        <span
          className="cursor-pointer hover:text-blue-100 hover:underline transition-colors"
          onClick={() => handleOpenLink("https://inexus-co.com/privacy-policy/")}
        >
          {i18n.t("MSG_SETTING_FOOTER_PRIVACY_POLICY")}
        </span>
        <span>|</span>
        <span
          className="cursor-pointer hover:text-blue-100 hover:underline transition-colors"
          onClick={() => handleOpenLink("https://inexus-co.com/contact/")}
        >
          {i18n.t("MSG_SETTING_FOOTER_INQUIRY")}
        </span>
      </footer>
    </div>
  );
};
